import React, { useState } from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer';
import { Divider } from '@mui/material';
import { setFileAllocateCompany, updateFileAllocation } from '../../../reducers/filesAllocationReducer';
import { getRequest } from '../../../config';

const isObjectId = (str) => typeof str === 'string' && /^[0-9a-fA-F]{24}$/.test(str);

const FileReportHistory = ({ modalType, reportHistories, setFileReport, setCloneImportResult, setCurrentScore, company, profileClass }) => {

    const dispatch = useDispatch()
    const [loadingReportId, setLoadingReportId] = useState(null);

    const getReportStatus = (report) => {
        if (!report) return "-";

        if (report['status'] == 'In Progress') {
            return <p className="orange">Not yet reviewed</p>;
        } else if (report['status'] == 'Complete') {
            return <p className="green">Reviewed and Accepted</p>;
        } else {
            return "-"
        }
    };

    const onClickReport = async (report) => {
        setLoadingReportId(report._id);
        try {
            const res = await getRequest(`/company/getFileReport/${report._id}`);
            const fullReport = res?.body || report;
            dispatch(setFileReport(fullReport))
            dispatch(setFileAllocateCompany(company))
            setCloneImportResult(JSON.parse(JSON.stringify(fullReport['importResult'] || {})));
            dispatch(setCurrentScore(fullReport['currentScore']))
            dispatch(updateFileAllocation({ moduleId: isObjectId(fullReport?.moduleName) ? fullReport.moduleName : null }))
            dispatch(toggleModal({ open: 'importSummary', from: 'reportHistory' }))
        } finally {
            setLoadingReportId(null);
        }
    };


    const getReportHistoryEntryHTML = report => {
        const isLoading = loadingReportId === report._id;
        return <>
            <tr className={`cp${isLoading ? ' o50' : ''}`} onClick={() => !loadingReportId && onClickReport(report)}>
                <td className={`mx1rem fs14px fw500 bg1 c2`}>
                    {moment(report['importDate']).format('lll')}
                    {isLoading && <span className="ml0-5rem fs12px c3"> Loading...</span>}
                </td>
                <td className={`frs-td mx1rem fs14px fw500 bg1 c2`}>
                    {report['importResultCount'] ?? 0}
                </td>
                <td className={`frs-td mx1rem fs14px fw500 bg1`}>
                    <span className={`w2rem h2rem jcc aic br100 bg1 c1 dib wsn`}>

                        {report?.['importBy']?.['profile']
                            ? <img src={report?.['importBy']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={report?.['importBy']?.['firstName'] ? (report?.['importBy']?.['firstName'] + " " + report?.['importBy']?.['lastName']) : "?"} />
                            : <span className={`wsn w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={report?.['importBy']?.['firstName'] ? (report?.['importBy']?.['firstName'] + " " + report?.['importBy']?.['lastName']) : "?"}>{report?.['importBy']?.['firstName'] ? (report?.['importBy']?.['firstName'][0] + (report?.['importBy']?.['lastName'] ? report?.['importBy']?.['lastName'][0] : "")) : "?"}</span>
                        }
                    </span>
                </td>
                <td className={`frs-td mx1rem fs14px fw500 bg1 c2`}>
                    {report?.['lastAllocatedBy'] && (
                        <span className={`w2rem h2rem jcc aic br100 dib c2`}>
                            {report?.['lastAllocatedBy']?.['profile']
                                ? <img src={report?.['lastAllocatedBy']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={report?.['lastAllocatedBy']?.['firstName'] ? (report?.['lastAllocatedBy']?.['firstName'] + " " + report?.['lastAllocatedBy']?.['lastName']) : "?"} />
                                : <span className={`wsn w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={report?.['lastAllocatedBy']?.['firstName'] ? (report?.['lastAllocatedBy']?.['firstName'] + " " + report?.['lastAllocatedBy']?.['lastName']) : "?"}>{report?.['lastAllocatedBy']?.['firstName'] ? (report?.['lastAllocatedBy']?.['firstName'][0] + (report?.['lastAllocatedBy']?.['lastName'] ? report?.['lastAllocatedBy']?.['lastName'][0] : "")) : "?"}</span>
                            }
                        </span>
                    )}

                </td>
                <td className={`frs-td mx1rem fs14px fw500 bg1 c2`}>
                    {report?.['initialScore']}{'% -> '}{report?.['currentScore']}{'%'}
                </td>
                <td className={`frs-td mx1rem fs14px fw500 bg1`}>
                    {getReportStatus(report)}
                </td>
            </tr>
        </>
    };

    return (
        <>
            <ModalWrapper
                modalType={modalType}
                modalCardClasses="maw1200px mah80 p2rem"
            >

                <div className='df fdc jcfs pr'>
                    <div className='df jcfs aic'>
                        <img src={require("../../../../images/dataRepo/file.svg")} alt={"fileManagement"} />
                        <h1 className="c15 fw600 fs20px mb0rem ml0-5rem">Filing Assistant Manager</h1>
                    </div>
                    <h1 className='c3 fs18px w100 fw400 mt0-5rem tal'>Filing Assistant</h1>
                </div>

                <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />

                <div className="dg gg0-5rem mb2rem fs1rem mah300px oya">
                    <table className="fis bcc frs-table">
                        <thead>
                            <tr>
                                <th className="fis-th frs-th fs14px fw400 c37 tal">Date</th>
                                <th className="fis-th frs-th fs14px fw400 c37">File Count</th>
                                <th className="fis-th frs-th fs14px fw400 c37">Import By</th>
                                <th className="fis-th frs-th fs14px fw400 c37">Reallocated By</th>
                                <th className="fis-th frs-th fs14px fw400 c37">Accuracy Change</th>
                                <th className="fis-th fs14px fw400 c37" style={{ minWidth: '124px' }}>Status</th>
                            </tr>
                        </thead>
                        {reportHistories.length > 0 && (
                            <tbody>
                                {reportHistories.map(getReportHistoryEntryHTML)}
                            </tbody>
                        )}
                    </table>
                    {reportHistories.length == 0 && (
                        <span className="fs1-25rem tac">No file report history</span>
                    )}
                </div>

            </ModalWrapper>
        </>
    )
}

export default FileReportHistory